import { HttpClient } from "./apiClient"

interface FindAllParams {
  skip?: number
  take?: number
  [key: string]: any // for additional query params like filters
}

export function crudFactory<T, CreateDto = Partial<T>, UpdateDto = Partial<T>>(
  endpoint: string
) {
  return {
    // GET /endpoint?skip=...&take=...&otherFilters=...
    findAll(params?: FindAllParams): Promise<{ data: T[]; total?: number }> {
      return HttpClient.get<{ data: T[]; total?: number }>(endpoint, { params })
    },

    // GET /endpoint/:id
    findOne(id: string | number): Promise<T> {
      return HttpClient.get<T>(`${endpoint}/${id}`)
    },

    // POST /endpoint
    create(data: CreateDto): Promise<T> {
      return HttpClient.post<T>(endpoint, data)
    },

    // PUT /endpoint/:id
    update(id: string | number, data: UpdateDto): Promise<T> {
      return HttpClient.put<T>(`${endpoint}/${id}`, data)
    },

    // DELETE /endpoint/:id
    remove(id: string | number): Promise<T> {
      return HttpClient.delete<T>(`${endpoint}/${id}`)
    },
  }
}
